import DeeplinkHandler from './DeeplinkHandler'
export default DeeplinkHandler